import { render, staticRenderFns } from "./PurchaseCancellationPolicy.vue?vue&type=template&id=17894d40&"
import script from "./PurchaseCancellationPolicy.vue?vue&type=script&lang=ts&"
export * from "./PurchaseCancellationPolicy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports